import { css, useTheme } from '@fable/theme'
import { Text } from '@fable/components'
import { AuthForm } from '../../../auth/components/auth_form/AuthForm'
import { FORM_TYPES } from '../../../auth/constants'
import { useFeaturedEvent } from '../../context'
import { postAuthRegisterEventKey } from '../../pages/FeaturedEvent'

export const FeaturedEventAuth: React.VFC = () => {
  const { event } = useFeaturedEvent()
  const { colors, mediaQueries } = useTheme()

  return (
    <div
      className={css`
        padding: 48px 0;
        background-color: ${colors.whiteFang};
        text-align: center;
        ${mediaQueries.mobileL} {
          padding: 48px;
        }
      `}
    >
      <div
        className={css`
          padding: 0 24px;
          ${mediaQueries.mobileL} {
            padding: 0;
          }
        `}
      >
        <Text
          className={css`
            margin-bottom: 16px;
          `}
          type="subhead"
          sizing={{ base: 'M', mobileL: 'L' }}
        >
          RSVP by signing in or
          <br />
          creating a free Fable account
        </Text>
        <Text
          className={css`
            margin: 0 auto;
            max-width: 426px;
          `}
          type="body"
          sizing={{ base: 'M', mobileL: 'L' }}
          text="Get access to this event, a world of book clubs, curated book
          reccomendations, and so much more"
        />
      </div>
      <AuthForm
        className={css`
          margin: 27px auto 0;
          .fds-ui--auth-sign-in-form {
            margin-top: 0;
          }
        `}
        type={FORM_TYPES.SIGN_UP}
        onSubmit={() => {
          localStorage.setItem(
            postAuthRegisterEventKey,
            event.eventId as string
          )
        }}
        signInSubmitTitle="RSVP and Log in"
        signUpSubmitTitle="RSVP and Create Account"
        hideHeader
      />
    </div>
  )
}
